import React, { FC, useMemo } from 'react';
import { motion } from 'framer-motion';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';


const StepsMobile: FC = (): JSX.Element => {
  const { currentStep, completedSteps, changeStep } = useWizard();

  const steps: WizardStep[] = useMemo(() => [
    WizardStep.REGION,
    WizardStep.CONTINENT,
    WizardStep.INDUSTRY,
    WizardStep.LICENCE_TYPE,
    WizardStep.COMPANY_TYPE,
    WizardStep.EXPENDED_MONTHLY_VOLUME,
    WizardStep.PROPOSAL,
    WizardStep.PROPOSAL_APPROVAL,
    WizardStep.APPROVAL_FORM
  ], []);

  return (
    <div className="steps-container-mobile">
      {/*<div className="steps-border"/>*/}
      <div className="steps-list-mobile">
        {currentStep === WizardStep.HOME || currentStep === WizardStep.THANK_YOU || currentStep === WizardStep.SORRY ? (
          <motion.div
            className="steps-list-text-mobile"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.2 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
          </motion.div>
        ) : (
          <>
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div key={`mobile-step-${step}`} className={`step-list-item-wrapper ${completedSteps[step] ? 'completed' : ''} ${step === currentStep ? 'active' : ''}`}>
                  <div
                    className={`steps-list-item-mobile ${completedSteps[step] ? 'completed' : ''} ${step === currentStep ? 'active' : ''}`}
                    onClick={() => {
                      if (completedSteps[step]) {
                        changeStep(step, true);
                      }
                    }}
                  >
                    {index + 1}
                  </div>
                </div>
                {index !== steps.length -1 && <div className={`step-list-item-bridge ${completedSteps[step] ? 'completed' : ''} ${step === currentStep ? 'active' : ''}`}/>}
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default StepsMobile;
